<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-items-center">
    <span class="wf-font-light wf-lowercase wf-text-gray-500 wf-w-1/2 wf-text-xs wf-tracking-wide" v-text="text"></span>
    <div class="wf-flex wf-justify-end wf-w-1/2">
      <ToggleButton sync v-model="value"/>
    </div>
  </li>
</template>

<script>
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    props: {
      text: {
        type: String,
        required: false,
        default: 'text'
      },
      property: {
        type: String,
        required: false,
        default: 'text'
      }
    },
    computed: {
      value: {
        get() {
          return this.elementContent[this.property]
        },
        set(value) {
          let object = new Object
          this.$set(object, this.property, value)
          this.addToObject(this.module, object, 'content', null, {}, true, this.parentModule)
        }
      },
    }
  })
</script>
